// Single source of truth for who sees the KPI Dashboard + Clinics screens.
//
//  - role 1 (super_admin): sees the two new pages *alongside* the existing four,
//    no matter which account they belong to.
//  - account 6: sees ONLY the two new pages; the existing four are hidden, and
//    login lands on the KPI dashboard.
export const KPI_ACCOUNT_ID = '6';
export const SUPER_ADMIN_ROLE = '1';

export const getAccountId = (): string => localStorage.getItem('account_id')?.trim() ?? '';

export const getRole = (): string => localStorage.getItem('role')?.trim() ?? '';

export const isSuperAdmin = (): boolean => getRole() === SUPER_ADMIN_ROLE;

// Can reach the KPI Dashboard / Clinics pages at all.
export const canViewKpiPages = (): boolean => isSuperAdmin() || getAccountId() === KPI_ACCOUNT_ID;

// Sees the KPI pages *instead of* the original four (super admins keep everything).
export const isKpiOnlyAccount = (): boolean => !isSuperAdmin() && getAccountId() === KPI_ACCOUNT_ID;

// Where a user lands right after logging in.
export const landingRoute = (): string => (isKpiOnlyAccount() ? '/kpi-dashboard' : '/dashboard?page=1');
